import { request } from "./client.js";
import { E } from "./endpoints.js";
import type { MeResponse } from "../types/user.js";

/** GET /v1/lk/me */
export async function getMe(): Promise<MeResponse> {
  return request<MeResponse>(E.lk.me, {});
}
